import { FC, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { localStorageGet } from '../../utils/localStorage';
import { pages } from '../../utils/common';

type RoleBasedRedirectProps = {
  children: React.ReactNode;
};

/**
 * Component that redirects users based on their role
 * - Guardian users are redirected to guardian module
 * - Other users continue to their intended route
 */
const RoleBasedRedirect: FC<RoleBasedRedirectProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorageGet('userRole');
  const isGuardian = userRole === 'guardian';
  const isGuardianRoute = location.pathname.startsWith(pages.guardian.path);
  const isLoginRoute = location.pathname === pages.auth.path || location.pathname === '/';

  useEffect(() => {
    // Skip redirect on login page
    if (isLoginRoute) {
      return;
    }

    // If user is guardian but not on guardian route, redirect to guardian
    if (isGuardian && !isGuardianRoute) {
      navigate(pages.guardian.path, { replace: true });
      return;
    }

    // If user is not guardian but on guardian route, redirect to dashboard
    if (!isGuardian && isGuardianRoute) {
      navigate(pages.dashboard.path, { replace: true });
      return;
    }
  }, [isGuardian, isGuardianRoute, isLoginRoute, navigate]);

  return <>{children}</>;
};

export default RoleBasedRedirect;
